import React from "react";

const PrintFooter = () => {
  return (
    <div className="print-footer">
      <hr className="print-footer-divider" />
    </div>
  );
};

export default PrintFooter;
